import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/images/arrow.png'


const _hoisted_1 = { class: "bg-everWhite6 md:pt-73px pt-0 pb-8 md:pb-61px" }
const _hoisted_2 = { class: "max-w-1200px w-full mx-auto" }
const _hoisted_3 = { class: "flex items-center justify-between flex-wrap flex-col md:flex-row" }
const _hoisted_4 = { class: "text-everGray6 text-14px" }
const _hoisted_5 = { class: "text-everPurple9 mt-4 text-40px font-extrabold" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-4 ml-1",
  alt: ""
}, null, -1)

import { isProd } from '@/constants'
import { useI18n } from 'vue-i18n'
import { computed, onMounted, reactive, ref } from 'vue'
import { toBN } from '@/libs/util'
import { getEverHomeData } from '../libs/api'
import { ElMessage, ElSkeleton } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n()
const info = reactive({
  totalVolume: '',
  totalTrades: '',
  totalWallets: '',
  tvl: ''
})
const tradingData = computed(() => {
  return [
    {
      title: t('tradingdata.total_volume'),
      data: formatNumber(info.totalVolume).toFormat().toString()
    },
    {
      title: t('tradingdata.total_trades'),
      data: formatNumber(info.totalTrades).toFormat().toString()
    },
    {
      title: t('tradingdata.total_wallets'),
      data: formatNumber(info.totalWallets).toFormat().toString()
    },
    {
      title: t('tradingdata.tvl'),
      data: formatNumber(info.tvl).toFormat().toString()
    }
  ]
})
const loading = ref(false)
const getDataInfo = async () => {
  try {
    loading.value = true
    const result = await getEverHomeData()
    info.totalWallets = result.walletNum.toString()
    info.totalTrades = result.txNum.toString()
    info.totalVolume = result.tradeVolume.reduce((num, item) => {
      return num.plus(item.volume)
    }, toBN(0)).toString()
    info.tvl = Object.values(result.locker).reduce((num, item) => {
      return num.plus(item.totalAmount)
    }, toBN(0)).toString()
    console.log(info)
    loading.value = false
  } catch (e:any) {
    loading.value = false
    if (e.message.includes('Network Error')) {
      ElMessage({
        message: t('network_error'),
        duration: 2000,
        showClose: true,
        type: 'error'
      })
    } else {
      ElMessage({
        message: e.message,
        duration: 2000,
        showClose: true,
        type: 'error'
      })
    }
  }
}
const formatNumber = (num:number | string) => {
  return toBN(+num).integerValue(1)
}
onMounted(() => {
  getDataInfo()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tradingData), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "flex flex-col md:items-start items-center md:mt-0 mt-10"
          }, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(item.title), 1),
            _createElementVNode("div", _hoisted_5, [
              (item.data && !loading.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(index % 3 ? '' : '$') + _toDisplayString(item.data), 1))
                : (_openBlock(), _createBlock(_unref(ElSkeleton), {
                    key: 1,
                    rows: 0,
                    animated: "",
                    style: {"width":"200px","height":"47px"}
                  }))
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("a", {
        class: "flex items-center text-everGray6 mt-6 text-xs leading-5 opacity-65 md:justify-start justify-center",
        href: `https://scan${_unref(isProd) ? '' : '-dev'}.everpay.io/`,
        target: "_blank"
      }, [
        _createTextVNode(_toDisplayString(_unref(t)('tradingdata.learn_more')) + " ", 1),
        _hoisted_8
      ], 8, _hoisted_7)
    ])
  ]))
}
}

})